export const timeSince = 'time_since';
export const timeUntil = 'time_until';
export const dateDurations = [timeSince, timeUntil];